module.exports = __webpack_public_path__ + "static/brain-075d18815cab794dc15f23bac588480c.png";